import React from 'react'
import PropTypes from 'prop-types';
import OfferChoiceApproval from "./OfferChoiceApproval";


function Index(
    {
        expanded
    }) {
    return expanded && <OfferChoiceApproval />
}

Index.propTypes = {
    expanded: PropTypes.bool,
}

export default Index;